import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  tr: {
    nav: {
      kurumsal: "Kurumsal",
      sektorler: "Sektörler",
      urunler: "Ürünlerimiz",
      sosyal: "Sosyal Sorumluluk",
      haberler: "Haberler",
      dokumanlar: "Dokümanlar",
      iletisim: "İletişim",
    },
    common: {
      readMore: "Devamını oku",
      viewDetail: "Detayı gör",
      send: "Gönder",
      required: "Zorunlu alanları doldurun.",
      submitOk: "Mesajınız alındı",
      submitDesc: "En kısa sürede sizinle iletişime geçeceğiz.",
      contactUs: "Bizi Arayın",
      loading: "Yükleniyor…",
    },
    home: {
      kicker: "Yaşayan Değerler",
    },
    kurumsal: {
      kicker: "Kurumsal",
      title: "Hakkımızda",
      subtitle:
        "1993 yılında Antalya'da temelleri atılan Koptur Grup, bugün altı farklı sektörde faaliyet gösteren köklü bir Türkiye markasıdır. Ürettiğimiz her değerde insanı ve toprağı merkezine alıyoruz.",
      storyTitle: "Yarım asırlık bir yolculuğun adı",
      storyP1:
        "Antalya'nın merkezinde başlayan küçük bir aile işletmesinden bugünün kurumsal grup yapısına uzanan yolculuğumuzda, hiçbir zaman değıştirmediğimiz tek şey oldu: sadelik, kalite ve alın teri.",
      storyP2:
        "Yaşanabilir mekanlar inşa etmenin, sadece binalarla değil; kentle, doğayla ve insanla kurulan uzun soluklu bir ilişkiden geçtiğine inanıyoruz.",
      years: "Yıllık Tecrübe",
      projects: "Tamamlanan Proje",
      areas: "Faaliyet Alanı",
      mission: "Misyonumuz",
      missionText:
        "Yüksek mühendislik standartları ve tasarım anlayışıyla; çevreye, kentlere ve insanlara değer katan projeler geliştirmek.",
      vision: "Vizyonumuz",
      visionText:
        "Faaliyet gösterdiğimiz her sektörde, sürdürülebilir büyüme anlayışıyla Türkiye'nin öncü kurumlarından biri olmak.",
      values: "Değerlerimiz",
      timeline: "Tarihçemiz",
    },
    sectors: {
      kicker: "Faaliyet Alanları",
      title: "Sektörlerimiz",
      subtitle:
        "Koptur Grup A.Ş. olarak inşaattan turizme, tarımdan enerjiye altı farklı sektörde değer üretiyor, sürdürülebilir bir gelecek inşa ediyoruz.",
    },
    csr: {
      kicker: "Sosyal Sorumluluk",
      title: "Toplumsal Değere Katkımız",
      subtitle:
        "Koptur Grup, kazandığını topluma döndüren bir kurum olma sorumluluğunu taşır. Eğitimden çevreye, kültürden spora geniş bir alanda destek olmaya devam ediyoruz.",
      badge: "Sosyal Etki",
    },
    news: {
      kicker: "Güncel",
      title: "Haberler",
      subtitle:
        "Koptur Grup'un projelerinden, faaliyetlerinden ve sektörel gelişmelerden haberdar olun.",
    },
    contact: {
      kicker: "İletişim",
      title: "Bize Ulaşın",
      subtitle:
        "Projeleriniz, iş birlikleri veya sorularınız için bize dilerseniz form aracılığıyla, dilerseniz doğrudan telefonla ulaşabilirsiniz.",
      address: "Adres",
      phone: "Telefon",
      email: "E-posta",
      formTitle: "Bize yazın",
      formDesc: "Formu doldurun, ekibimiz size kısa sürede dönüş yapsın.",
      name: "Ad Soyad",
      namePh: "Adınız Soyadınız",
      emailPh: "eposta@ornek.com",
      phonePh: "+90 5XX XXX XX XX",
      message: "Mesajınız",
      messagePh: "Kısaca bize yazmak istediklerinizi paylaşın...",
    },
  },
  en: {
    nav: {
      kurumsal: "Corporate",
      sektorler: "Sectors",
      urunler: "Products",
      sosyal: "Social Responsibility",
      haberler: "News",
      dokumanlar: "Documents",
      iletisim: "Contact",
    },
    common: {
      readMore: "Read more",
      viewDetail: "View detail",
      send: "Send",
      required: "Please fill in the required fields.",
      submitOk: "Message received",
      submitDesc: "We will get back to you shortly.",
      contactUs: "Call us",
      loading: "Loading…",
    },
    home: {
      kicker: "Living Values",
    },
    kurumsal: {
      kicker: "Corporate",
      title: "About Us",
      subtitle:
        "Founded in Antalya in 1993, Koptur Grup is a well-established Turkish brand operating in six different sectors today. We place people and the land at the center of every value we create.",
      storyTitle: "A journey of nearly half a century",
      storyP1:
        "From a small family business born in the heart of Antalya to today's corporate group, one thing never changed on our journey: simplicity, quality and honest labor.",
      storyP2:
        "We believe that building livable spaces goes far beyond buildings — it grows out of a long-lasting relationship with the city, nature and people.",
      years: "Years of Experience",
      projects: "Completed Projects",
      areas: "Business Areas",
      mission: "Our Mission",
      missionText:
        "To develop projects that add value to the environment, cities and people through high engineering standards and thoughtful design.",
      vision: "Our Vision",
      visionText:
        "To become one of Turkey's leading institutions in every sector we operate in, guided by sustainable growth.",
      values: "Our Values",
      timeline: "Our History",
    },
    sectors: {
      kicker: "Business Areas",
      title: "Our Sectors",
      subtitle:
        "From construction to tourism, from agriculture to energy, we create value across six different sectors and build a sustainable future.",
    },
    csr: {
      kicker: "Social Responsibility",
      title: "Our Contribution to Society",
      subtitle:
        "Koptur Grup bears the responsibility of giving back what it earns. We continue to support education, environment, culture and sports.",
      badge: "Social Impact",
    },
    news: {
      kicker: "Latest",
      title: "News",
      subtitle: "Follow the latest projects, activities and news from Koptur Grup.",
    },
    contact: {
      kicker: "Contact",
      title: "Get in Touch",
      subtitle:
        "Reach us via the form below or directly by phone for your projects, partnerships or any questions.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      formTitle: "Write to us",
      formDesc: "Fill out the form and our team will respond shortly.",
      name: "Full Name",
      namePh: "Your name",
      emailPh: "you@example.com",
      phonePh: "+1 555 555 5555",
      message: "Message",
      messagePh: "Briefly share what you would like to tell us...",
    },
  },
};

const LangCtx = createContext({ lang: "tr", setLang: () => {}, t: (k) => k });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("koptur_lang") || "tr");

  useEffect(() => {
    localStorage.setItem("koptur_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = DICT[lang];
    for (const p of parts) {
      if (cur && typeof cur === "object" && p in cur) cur = cur[p];
      else return path;
    }
    return cur;
  };

  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
